import NullTableRegion from "../table/NullTableRegion"
import LockTableRegion from "./LockTableRegion"
import SelectionController from "../table/SelectionController"
import _ from "underscore"
import RunnerSelectionType from './RunnerSelectionType'

export default class LockTableSelectionController extends SelectionController {
    constructor() {
        super();
        this.selectionType = null;
        this.lockTable = null;
    }

    setLockTable(lockTable) {
        this.lockTable = lockTable;
    }

    isLeftmostSelectedCell(cell) {
        if (this.isSelected(cell.getRow().getRowIdx(), cell.getColIdx()))
            return this.selectedRegion.colMin == cell.getColIdx();
    }

    isUpwardmostSelectedCell(cell) {
        if (this.isSelected(cell.getRow().getRowIdx(), cell.getColIdx()))
            return this.selectedRegion.rowMin == cell.getRow().getRowIdx();
    }

    isRightmostSelectedCell(cell) {
        if (this.isSelected(cell.getRow().getRowIdx(), cell.getColIdx()))
            return this.selectedRegion.colMax == cell.getColIdx();
    }

    isDownwardmostSelectedCell(cell) {
        if (this.isSelected(cell.getRow().getRowIdx(), cell.getColIdx()))
            return this.selectedRegion.rowMax == cell.getRow().getRowIdx();
    }

    visitSelection(visitor) {
        if (this.selectionType !== null)
            return this.selectionType.accept(visitor, this.getSelection());
    }

    setSelectionType(selectionType) {
        var oldSelection = this.getSelection();
        this.selectionType = selectionType;
        this.fireSelectionChangeEvent(oldSelection);
    }

    createSelection(cell) {
        return LockTableRegion.prototype.createFromCells(this.selectionType, this.lockTable, this.selectionAnchor, cell)
    }

    isSelected(rowIdx, colIdx) {
        if (this._isRunnerAfterLastVisibleDaySelection(colIdx)) return false
        return super.isSelected(rowIdx, colIdx)
    }

    isColumnIncludedIntoSelection(colIdx) {
        if (this._isRunnerAfterLastVisibleDaySelection(colIdx)) return false
        return this.selectedRegion.containsCol(colIdx)
    }

    clearSelection() {
        this.selectionAnchor = null;
        if (this.hasSelection()) {
            var oldSelection = this.getSelection();
            this.selectionType = null;
            this.selectedRegion = NullTableRegion;
            this.fireSelectionChangeEvent(oldSelection);
        }
    }

    hasSelection() {
        return this.selectedRegion !== NullTableRegion || this.selectionType !== null;
    }

    isRowIncludedIntoSelection(rowIdx) {
        return this.visitSelection({
            visitCellSelection(selection) {
                if (selection != NullTableRegion)
                    return selection.rowMin <= rowIdx && rowIdx <= selection.rowMax;
                return false;
            },
            visitDateSelection: _.constant(true),
            visitRunnerSelection: _.constant(true)
        });
    }

    _isRunnerAfterLastVisibleDaySelection(colIdx) {
        if (this.selectionType instanceof RunnerSelectionType && this.selectedRegion.colMax === this.selectedRegion.colMin) {
            const datesRowCells = this.lockTable.selectionController.lockTable.datesRow.cells
            const newLastLockedDate = this.lockTable.runnerController.newLastLockedCell.value.date
            const lastVisibleDateRow = datesRowCells[datesRowCells.length - 1]

            if (colIdx === datesRowCells.length - 1
                && lastVisibleDateRow.value.date < this.lockTable.runnerController.lastLockedDate
                && newLastLockedDate === lastVisibleDateRow.value.date) {
                return true
            }
        }
        return false
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTableSelectionController.js